import React from 'react';
import { MercuryGroup, MercuryZone } from 'mercury-react-sdk';

const MercuryComponent = (apiUrl, renderersUrl, interactionEnabled, idGroup, idZone) => {
  return (
    <MercuryGroup
      apiUrl={apiUrl}
      tokenUrl={'/cgi-bin/transac/dotrxajax?TMPL=/security/passport.json&intends='}
      renderersUrl={renderersUrl}
      id={idGroup}
      withEventstream={false}
      tokenExpireTime={40000}
      interactionEnabled={interactionEnabled}
    >
      <MercuryZone id={idZone} />
    </MercuryGroup>
  );
};

export default MercuryComponent;
